
export interface TimeZone {
    /**
     * Time zone label displayed to users
     */
    label: string;
    /**
     * Value accepted by the API. This will be a .NET TimeZoneInfo Id
     */
    value: string;
}

export function TimeZonesFactory(
    gettextCatalog:ng.gettext.gettextCatalog
): TimeZone[] {
    /**
     * @ngdoc service
     * @name sharebase.timezones.sbTimeZones
     * 
     * @description
     * 
     * Provides a list of available time zones with localized labels.
     */
    return [
        {
            label: gettextCatalog.getString('(UTC+14:00) Line Islands Standard Time (Pacific/Kiritimati)'),
            value: 'Line Islands Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+13:00) Tonga Standard Time (Pacific/Tongatapu)'),
            value: 'Tonga Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+13:00) Samoa Standard Time (Pacific/Apia)'),
            value: 'Samoa Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+12:45) Chatham Islands Standard Time (Pacific/Chatham)'),
            value: 'Chatham Islands Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+12:00) UTC+12 (Etc/GMT-12)'),
            value: 'UTC+12'
        },
        {
            label: gettextCatalog.getString('(UTC+12:00) Russia TZ 11 Standard Time (Asia/Kamchatka)'),
            value: 'Russia Time Zone 11'
        },
        {
            label: gettextCatalog.getString('(UTC+12:00) New Zealand Standard Time (Pacific/Auckland)'),
            value: 'New Zealand Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+12:00) Fiji Standard Time (Pacific/Fiji)'),
            value: 'Fiji Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+11:00) Sakhalin Standard Time (Asia/Sakhalin)'),
            value: 'Sakhalin Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+11:00) Russia TZ 10 Standard Time (Asia/Srednekolymsk)'),
            value: 'Russia Time Zone 10'
        },
        {
            label: gettextCatalog.getString('(UTC+11:00) Norfolk Standard Time (Pacific/Norfolk)'),
            value: 'Norfolk Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+11:00) Magadan Standard Time (Asia/Magadan)'),
            value: 'Magadan Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+11:00) Central Pacific Standard Time (Pacific/Guadalcanal)'),
            value: 'Central Pacific Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+11:00) Bougainville Standard Time (Pacific/Bougainville)'),
            value: 'Bougainville Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+10:30) Lord Howe Standard Time (Australia/Lord_Howe)'),
            value: 'Lord Howe Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+10:00) West Pacific Standard Time (Pacific/Port_Moresby)'),
            value: 'West Pacific Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+10:00) Tasmania Standard Time (Australia/Hobart)'),
            value: 'Tasmania Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+10:00) Russia TZ 9 Standard Time (Asia/Vladivostok)'),
            value: 'Vladivostok Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+10:00) E. Australia Standard Time (Australia/Brisbane)'),
            value: 'E. Australia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+10:00) AUS Eastern Standard Time (Australia/Sydney)'),
            value: 'AUS Eastern Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+09:30) Cen. Australia Standard Time (Australia/Adelaide)'),
            value: 'Cen. Australia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+09:30) AUS Central Standard Time (Australia/Darwin)'),
            value: 'AUS Central Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+09:00) Transbaikal Standard Time (Asia/Chita)'),
            value: 'Transbaikal Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+09:00) Tokyo Standard Time (Asia/Tokyo)'),
            value: 'Tokyo Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+09:00) Russia TZ 8 Standard Time (Asia/Yakutsk)'),
            value: 'Yakutsk Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+09:00) Korea Standard Time (Asia/Seoul)'),
            value: 'Korea Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+08:45) Aus Central W. Standard Time (Australia/Eucla)'),
            value: 'Aus Central W. Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+08:30) North Korea Standard Time (Asia/Pyongyang)'),
            value: 'North Korea Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+08:00) W. Australia Standard Time (Australia/Perth)'),
            value: 'W. Australia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+08:00) Ulaanbaatar Standard Time (Asia/Ulaanbaatar)'),
            value: 'Ulaanbaatar Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+08:00) Taipei Standard Time (Asia/Taipei)'),
            value: 'Taipei Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+08:00) Russia TZ 7 Standard Time (Asia/Irkutsk)'),
            value: 'North Asia East Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+08:00) Malay Peninsula Standard Time (Asia/Singapore)'),
            value: 'Singapore Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+08:00) China Standard Time (Asia/Shanghai)'),
            value: 'China Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+07:00) W. Mongolia Standard Time (Asia/Hovd)'),
            value: 'W. Mongolia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+07:00) Tomsk Standard Time (Asia/Tomsk)'),
            value: 'Tomsk Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+07:00) SE Asia Standard Time (Asia/Bangkok)'),
            value: 'SE Asia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+07:00) Russia TZ 6 Standard Time (Asia/Krasnoyarsk)'),
            value: 'North Asia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+07:00) Novosibirsk Standard Time (Asia/Novosibirsk)'),
            value: 'N. Central Asia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+07:00) Altai Standard Time (Asia/Barnaul)'),
            value: 'Altai Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+06:30) Myanmar Standard Time (Asia/Rangoon)'),
            value: 'Myanmar Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+06:00) Omsk Standard Time (Asia/Omsk)'),
            value: 'Omsk Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+06:00) Central Asia Standard Time (Asia/Almaty)'),
            value: 'Central Asia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+06:00) Bangladesh Standard Time (Asia/Dhaka)'),
            value: 'Bangladesh Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+05:45) Nepal Standard Time (Asia/Katmandu)'),
            value: 'Nepal Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+05:30) Sri Lanka Standard Time (Asia/Colombo)'),
            value: 'Sri Lanka Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+05:30) India Standard Time (Asia/Calcutta)'),
            value: 'India Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+05:00) West Asia Standard Time (Asia/Tashkent)'),
            value: 'West Asia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+05:00) Russia TZ 4 Standard Time (Asia/Yekaterinburg)'),
            value: 'Ekaterinburg Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+05:00) Pakistan Standard Time (Asia/Karachi)'),
            value: 'Pakistan Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+04:30) Afghanistan Standard Time (Asia/Kabul)'),
            value: 'Afghanistan Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+04:00) Russia TZ 3 Standard Time (Europe/Samara)'),
            value: 'Russia Time Zone 3'
        },
        {
            label: gettextCatalog.getString('(UTC+04:00) Mauritius Standard Time (Indian/Mauritius)'),
            value: 'Mauritius Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+04:00) Georgian Standard Time (Asia/Tbilisi)'),
            value: 'Georgian Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+04:00) Caucasus Standard Time (Asia/Yerevan)'),
            value: 'Caucasus Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+04:00) Azerbaijan Standard Time (Asia/Baku)'),
            value: 'Azerbaijan Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+04:00) Astrakhan Standard Time (Europe/Astrakhan)'),
            value: 'Astrakhan Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+04:00) Arabian Standard Time (Asia/Dubai)'),
            value: 'Arabian Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+03:30) Iran Standard Time (Asia/Tehran)'),
            value: 'Iran Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+03:00) Turkey Standard Time (Europe/Istanbul)'),
            value: 'Turkey Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+03:00) Russia TZ 2 Standard Time (Europe/Moscow)'),
            value: 'Russian Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+03:00) E. Africa Standard Time (Africa/Nairobi)'),
            value: 'E. Africa Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+03:00) Belarus Standard Time (Europe/Minsk)'),
            value: 'Belarus Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+03:00) Arabic Standard Time (Asia/Baghdad)'),
            value: 'Arabic Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+03:00) Arab Standard Time (Asia/Riyadh)'),
            value: 'Arab Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) West Bank Gaza Standard Time (Asia/Hebron)'),
            value: 'West Bank Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) Syria Standard Time (Asia/Damascus)'),
            value: 'Syria Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) South Africa Standard Time (Africa/Johannesburg)'),
            value: 'South Africa Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) Russia TZ 1 Standard Time (Europe/Kaliningrad)'),
            value: 'Kaliningrad Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) Middle East Standard Time (Asia/Beirut)'),
            value: 'Middle East Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) Libya Standard Time (Africa/Tripoli)'),
            value: 'Libya Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) Jordan Standard Time (Asia/Amman)'),
            value: 'Jordan Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) Jerusalem Standard Time (Asia/Jerusalem)'),
            value: 'Israel Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) GTB Standard Time (Europe/Bucharest)'),
            value: 'GTB Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) FLE Standard Time (Europe/Kiev)'),
            value: 'FLE Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) Egypt Standard Time (Africa/Cairo)'),
            value: 'Egypt Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+02:00) E. Europe Standard Time (Europe/Chisinau)'),
            value: 'E. Europe Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+01:00) W. Europe Standard Time (Europe/Berlin)'),
            value: 'W. Europe Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+01:00) W. Central Africa Standard Time (Africa/Lagos)'),
            value: 'W. Central Africa Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+01:00) Romance Standard Time (Europe/Paris)'),
            value: 'Romance Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+01:00) Namibia Standard Time (Africa/Windhoek)'),
            value: 'Namibia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+01:00) Central European Standard Time (Europe/Warsaw)'),
            value: 'Central European Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+01:00) Central Europe Standard Time (Europe/Budapest)'),
            value: 'Central Europe Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+00:00) GMT Standard Time (Europe/London)'),
            value: 'GMT Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+00:00) Greenwich Standard Time (Atlantic/Reykjavik)'),
            value: 'Greenwich Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+00:00) Morocco Standard Time (Africa/Casablanca)'),
            value: 'Morocco Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC+00:00) UTC (Etc/GMT)'),
            value: 'UTC'
        },
        {
            label: gettextCatalog.getString('(UTC-01:00) Azores Standard Time (Atlantic/Azores)'),
            value: 'Azores Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-01:00) Cabo Verde Standard Time (Atlantic/Cape_Verde)'),
            value: 'Cape Verde Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-02:00) UTC-02 (Etc/GMT+2)'),
            value: 'UTC-02'
        },
        {
            label: gettextCatalog.getString('(UTC-03:00) Argentina Standard Time (America/Buenos_Aires)'),
            value: 'Argentina Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-03:00) Bahia Standard Time (America/Bahia)'),
            value: 'Bahia Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-03:00) E. South America Standard Time (America/Sao_Paulo)'),
            value: 'E. South America Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-03:00) Greenland Standard Time (America/Godthab)'),
            value: 'Greenland Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-03:00) Montevideo Standard Time (America/Montevideo)'),
            value: 'Montevideo Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-03:00) SA Eastern Standard Time (America/Cayenne)'),
            value: 'SA Eastern Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-03:00) Saint Pierre Standard Time (America/Miquelon)'),
            value: 'Saint Pierre Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-03:00) Tocantins Standard Time (America/Araguaina)'),
            value: 'Tocantins Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-03:30) Newfoundland Standard Time (America/St_Johns)'),
            value: 'Newfoundland Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-04:00) Atlantic Standard Time (America/Halifax)'),
            value: 'Atlantic Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-04:00) Central Brazilian Standard Time (America/Cuiaba)'),
            value: 'Central Brazilian Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-04:00) Pacific SA Standard Time (America/Santiago)'),
            value: 'Pacific SA Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-04:00) Paraguay Standard Time (America/Asuncion)'),
            value: 'Paraguay Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-04:00) SA Western Standard Time (America/La_Paz)'),
            value: 'SA Western Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-04:00) Turks and Caicos Standard Time (America/Grand_Turk)'),
            value: 'Turks And Caicos Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-04:00) Venezuela Standard Time (America/Caracas)'),
            value: 'Venezuela Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-05:00) Cuba Standard Time (America/Havana)'),
            value: 'Cuba Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-05:00) Eastern Standard Time (America/New_York)'),
            value: 'Eastern Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-05:00) Eastern Standard Time (Mexico) (America/Cancun)'),
            value: 'Eastern Standard Time (Mexico)'
        },
        {
            label: gettextCatalog.getString('(UTC-05:00) Haiti Standard Time (America/Port-au-Prince)'),
            value: 'Haiti Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-05:00) SA Pacific Standard Time (America/Bogota)'),
            value: 'SA Pacific Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-05:00) US Eastern Standard Time (America/Indianapolis)'),
            value: 'US Eastern Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-06:00) Canada Central Standard Time (America/Regina)'),
            value: 'Canada Central Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-06:00) Central America Standard Time (America/Guatemala)'),
            value: 'Central America Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-06:00) Central Standard Time (America/Chicago)'),
            value: 'Central Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-06:00) Central Standard Time (Mexico) (America/Mexico_City)'),
            value: 'Central Standard Time (Mexico)'
        },
        {
            label: gettextCatalog.getString('(UTC-06:00) Easter Island Standard Time (Pacific/Easter)'),
            value: 'Easter Island Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-07:00) Mountain Standard Time (America/Denver)'),
            value: 'Mountain Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-07:00) Mountain Standard Time (Mexico) (America/Chihuahua)'),
            value: 'Mountain Standard Time (Mexico)'
        },
        {
            label: gettextCatalog.getString('(UTC-07:00) US Mountain Standard Time (America/Phoenix)'),
            value: 'US Mountain Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-08:00) Pacific Standard Time (America/Los_Angeles)'),
            value: 'Pacific Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-08:00) Pacific Standard Time (Mexico) (America/Tijuana)'),
            value: 'Pacific Standard Time (Mexico)'
        },
        {
            label: gettextCatalog.getString('(UTC-08:00) UTC-08 (Etc/GMT+8)'),
            value: 'UTC-08'
        },
        {
            label: gettextCatalog.getString('(UTC-09:00) Alaskan Standard Time (America/Anchorage)'),
            value: 'Alaskan Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-09:00) UTC-09 (Etc/GMT+9)'),
            value: 'UTC-09'
        },
        {
            label: gettextCatalog.getString('(UTC-09:30) Marquesas Standard Time (Pacific/Marquesas)'),
            value: 'Marquesas Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-10:00) Aleutian Standard Time (America/Adak)'),
            value: 'Aleutian Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-10:00) Hawaiian Standard Time (Pacific/Honolulu)'),
            value: 'Hawaiian Standard Time'
        },
        {
            label: gettextCatalog.getString('(UTC-11:00) UTC-11 (Etc/GMT+11)'),
            value: 'UTC-11'
        },
        {
            label: gettextCatalog.getString('(UTC-12:00) Dateline Standard Time (Etc/GMT+12)'),
            value: 'Dateline Standard Time'
        }
    ];
}

TimeZonesFactory.$inject = [
    'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase/services/timeZones.ts